import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { alpha, styled } from "@mui/material/styles";

const shouldForwardProp = (prop: PropertyKey) => prop !== "red";

export const Root = styled(Box, { shouldForwardProp })<{
  $red: boolean;
}>(({ theme, $red }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  alignSelf: "stretch",
  overflow: "hidden",
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  border: `0.0625rem solid ${$red ? theme.palette.error.main : theme.palette.divider}`,
  backgroundColor: $red ? alpha(theme.palette.error.light, 0.1) : "none",
}));

export const Text = styled(Typography, { shouldForwardProp })<{
  $red: boolean;
}>(({ theme, $red }) => ({
  color: $red ? theme.palette.error.main : grey[700],

  ...(theme.palette.mode === "dark" &&
    !$red && {
      color: grey[300],
    }),
}));
